import {useMemo} from 'react';
import {useInfiniteQuery} from 'react-query';
import reactQueryKeys from 'helpers/reactQueryKeys';
import {getAPIWithFilters} from 'data.api';
import {openingJobs} from 'api_urls';

export const useJobboardList = ({
  filters,
  searchTerm,
  isInternal,
  setFilters,
}) => {
  const {
    isLoading,
    isError,
    refetch,
    fetchNextPage,
    hasNextPage,
    isFetchingNextPage,
    data,
  } = useInfiniteQuery(
    [
      reactQueryKeys.ALL_POSTED_JOB_LIST,
      {
        ...filters,
        keyword: searchTerm,
        limit: 10,
        isInternal: isInternal ? 1 : '0',
      },
    ],
    ({pageParam = 0, queryKey}) => {
      return getAPIWithFilters(
        {
          ...queryKey[1],
          offset: pageParam,
        },
        openingJobs,
      );
    },
    {
      onSettled: (...args) => {
        // console.log({args});
      },
      // cacheTime: 2 * 60 * 1000,
      // staleTime: 2 * 60 * 1000,
      // enabled: conditionForEnabled,
      getNextPageParam: (lastPage, pages) => {
        if (
          !lastPage ||
          lastPage.data?.pagination?.to >= lastPage.data?.pagination?.total ||
          !lastPage.data?.pagination?.next
        )
          return;
        return lastPage.data?.pagination?.to;
      },
    },
  );

  const jobboardList = useMemo(() => {
    return (data?.pages || []).reduce(
      (list, p) => list.concat(p.data?.data || []),
      [],
    );
  }, [data]);

  return {
    isLoading,
    data,
    jobboardList,
    fetchNextPage,
    hasNextPage,
    isFetchingNextPage,
    refetch,
  };
};
